var path = '/opt/atlassian/pipelines/agent/build/src/app/components/timeline/timeline-detail/timeline-details.html';
var html = "<repository-list details=$ctrl.details page-title=Curriculum on-add=$ctrl.add() go-back-state={{$ctrl.goTOBack}} on-edit=$ctrl.editTimeline()> </repository-list>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/timeline/timeline-detail/timeline-details.html
// module id = 980
// module chunks = 0